import { useState, useEffect } from "react";
import axios from "axios";
// import Markdown from "@uiw/react-markdown-preview";
import { API_URL } from "../../creds";
import { useDiffCache } from "../../context/DiffCacheContext";
import { renderHTML } from "../../utils/Constant";

export default function FileViewModal({
  taskId,
  isOpen,
  onClose,
  rtlSource,
  rtlTarget,
}) {
  const [sourceText, setSourceText] = useState("");
  const [targetText, setTargetText] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const cacheRef = useDiffCache();

  // 🔹 Fetch Task Data
  useEffect(() => {
    if (!isOpen || !taskId) return;
    if (!cacheRef.current) {
      console.warn("cacheRef.current is null - initializing");
      cacheRef.current = new Map();
    }
    const cached = cacheRef.current.get(`${taskId}_view`);
    if (cached) {
      setSourceText(cached.source_content);
      setTargetText(cached.target_content);
      console.log("cacheRef.current:", cacheRef?.current);
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        setError("");

        const response = await axios.post(
          `${API_URL}/view-tasks/`,
          { taskid: taskId },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              "Content-Type": "application/json",
            },
          }
        );

        const { source_content, target_content } = response.data;
        setSourceText(source_content || "");
        setTargetText(target_content || "");
        cacheRef.current.set(`${taskId}_view`, { source_content, target_content });
      } catch (err) {
        console.error(err);
        setError("Failed to load task files.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();

  }, [isOpen, taskId, cacheRef]);

  if (!isOpen) return null;

  const sourceLang = rtlSource === "ur" ? "rtl-mode" : "";
  const targetLang = rtlTarget === "ur" ? "rtl-mode" : "";

  console.log("lang pair:", sourceLang, "-->>>", targetLang)

  // 🔹 Convert Pandoc-style images



  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl w-full max-w-7xl max-h-[95vh] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="px-6 py-4 border-b bg-gray-100 flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-800">
            Task Files — {taskId}
          </h2>
          <button
            onClick={onClose}
            className="text-3xl text-gray-600 hover:text-black"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 p-2 overflow-auto bg-gray-50">
          {loading ? (
            <div className="flex items-center justify-center h-full text-gray-500 text-lg">
              Loading contents...
            </div>
          ) : error ? (
            <div className="flex items-center justify-center h-full text-red-600 text-lg">
              {error}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 h-full">

              {/* SOURCE PANEL */}
              <div className="flex flex-col h-full">
                <h3 className="font-semibold text-lg mb-2 text-blue-600">
                  Source File
                </h3>

                <div
                  className={`flex-1 bg-white rounded-lg p-6 overflow-auto shadow border text-base ${sourceLang ? "urdu-font" : ""}`}
                  style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}

                  dangerouslySetInnerHTML={renderHTML(sourceText)}
                />
              </div>

              {/* TARGET PANEL */}
              <div className="flex flex-col h-full">
                <h3 className="font-semibold text-lg mb-2 text-green-600">
                  Target File
                </h3>
                <div
                  className={`flex-1 bg-white rounded-lg p-6 overflow-auto shadow border text-base ${targetLang ? "urdu-font" : ""}`}
                  style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}

                  dangerouslySetInnerHTML={renderHTML(targetText)}
                />
              </div>
            </div>

          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t bg-gray-100 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gray-800 text-white rounded hover:bg-black transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
